import * as React from 'react';
import { observer } from 'mobx-react';

import { DropdownView } from 'src/core/ui/dropdown.view';

interface RegionEditorViewProps {
	regionRequest: DropdownRequest<RegionSummary>;
	value: number | number[] | null;
	mode: ControlMode;
	onChanged: (number: RegionSummary | RegionSummary[]) => void;
	label?: string;
	required?: boolean;
	multi?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
	afterLoad?: (selectedOptions: any, options: any[]) => void;
}

@observer
export class RegionEditorView extends React.Component<RegionEditorViewProps, any> {
	constructor(props) {
		super(props);
	}

	render() {
		let label = this.props.label;
		if (label === undefined) {
			label = 'Region';
		}

		return (
			<DropdownView
				onGetErrorMessage={this.props.onGetErrorMessage}
				label={label}
				multi={this.props.multi}
				model={this.props.value}
				required={this.props.required}
				disabled={this.props.mode == 'display'}
				onChanged={this.props.onChanged}
				request={this.props.regionRequest}
				keyField='id'
				textField='displayName'
				afterLoad={this.props.afterLoad}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/regions/parts/region-editor.view.tsx